module.exports = "/_next/static/images/HeaderLogoModal-5d2568f867f1da597561078f5d9fdc09.svg";